import { SvgIcon } from "@mui/material";
import React from "react";


function CloudIcon(props) {
    return (
      <SvgIcon {...props}>
        <g transform="translate(0.000000,1058.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
            <path d="M4650 10569 c-937 -70 -1724 -444 -1965 -934 -63 -129 -79 -198 -79
            -335 1 -173 44 -305 151 -455 l50 -69 -206 -42 c-796 -160 -1448 -506 -1942
            -1029 -533 -565 -761 -1317 -614 -2025 71 -342 239 -691 479 -995 99 -125 319
            -345 451 -450 535 -428 1211 -698 1980 -792 214 -25 767 -26 975 0 309 39 595
            101 850 186 l145 49 112 -75 c398 -263 898 -438 1448 -505 147 -17 702 -18
            845 0 439 54 811 162 1153 334 348 174 599 371 843 662 l40 49 84 -32 c182
            -69 425 -128 670 -163 62 -8 192 -13 370 -12 297 0 411 12 663 69 493 110 953
            367 1244 695 248 279 382 591 400 926 21 407 -141 797 -467 1124 -171 172
            -359 306 -593 421 -74 37 -87 47 -83 64 3 11 11 90 18 176 38 514 -107 1044
            -412 1501 -121 182 -201 279 -360 438 -530 531 -1271 877 -2090 975 -181 22
            -597 31 -775 16 -368 -30 -711 -104 -1029 -220 l-136 -49 -88 55 c-526 332
            -1339 500 -2132 442z"/>
            </g>
      </SvgIcon>
    );
  }

export default CloudIcon;